import React, { useRef} from "react";
import { SellerDrawerList } from "../../components/SellerDrawerList";
import { SellerRoutes } from "../../../Routes/SellerRoutes";


export const SellerDashBoard = () => {
  const toggleDrawer = () => {};
  const mainRef = useRef<HTMLDivElement>(null);


  return (
    <div className="">
      <div className="lg:flex lg:h-[100%]">
       
         <aside
            className="hidden lg:block h-full lg:pr-6 self-start lg:sticky lg:top-24"
          
          >
            <SellerDrawerList toggleDrawer={toggleDrawer} />
          </aside>
        {/* redirect to related route */}
        
         <main ref={mainRef} className="min-w-0 lg:pl-6 lg:p-10 w-full lg:w-[80%] ">
            <SellerRoutes />
          </main>
      </div>
    </div>
  );
};
